import React, { useEffect, useState } from "react";
import { AiOutlineArrowUp } from "react-icons/ai";
import { Box, Button } from "@chakra-ui/react";

export default function TopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {isVisible && (
        <Box
          onClick={scrollToTop}
          position="fixed"
          bottom={"20px"}
          right={["16px", "20px"]}
          zIndex={3}
        >
          <Button bgColor={"#ed1b24"} color={"white"} variant="solid">
            <AiOutlineArrowUp size={"30"} color="white" />
          </Button>
        </Box>
      )}
    </>
  );
}
